import React, { useState } from "react";
import { Button, Icon } from "antd";
import config from "appConfig";
import styles from "./mobileAppBanner.scss";
import { MobileOS, PageRoute } from "../../models/enums";
import { getImageUrl } from "../../services/asset";
import { getMobileOS } from "../../services";
function MobileAppBanner(props: any) {
  const [closed, setClosed] = useState(false);
  const [triedOpen, setTriedOpen] = useState(false);

  const onClose = () => {
    setClosed(true);
  };

  const openMobileApp = (os: any) => {
    let pageLink = "/";
    const { mobileLink } = config;
    const { pathname, currentAd } = props;

    if (pathname.includes(PageRoute.details)) {
      if (currentAd && currentAd.summary) {
        pageLink += `${PageRoute.details}/${currentAd.summary.id}`;
      }
    } else {
      pageLink += "/";
    }

    if (os === MobileOS.android) {
      const appLink = mobileLink.androidApp.replace(
        mobileLink.appPageToken,
        pageLink
      );
      const storeLink = `S.browser_fallback_url=${mobileLink.googlePlay}`;

      window.location.href = `${appLink};${storeLink};end`;
    } else if (os === MobileOS.iOS) {
      if (triedOpen) {
        window.location.href = mobileLink.appStore;
      } else {
        window.location.href = mobileLink.iOSApp.replace(
          mobileLink.appPageToken,
          pageLink
        );
        setTriedOpen(true);
      }
    }
  };

  const os = getMobileOS();

  if (closed || !os) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <Icon className={styles.icon} type="close" onClick={onClose} />
      <img
        className={styles.bannerImage}
        src={getImageUrl("logo-small.svg")}
        alt="appImage"
      />
      <span className={styles.message}>
        {"Otvorite aplikaciju "}
        <span className={styles.appName}>
          {"Index Oglasi"}
        </span>
        {" za bolju upotrebu"}
      </span>
      <Button
        type="primary"
        onClick={() => {
          openMobileApp(os);
        }}
        className={styles.openBtn}
      >
        {triedOpen
          ? "Instalirati"
          : "Otvori"}
      </Button>
    </div>
  );
}

MobileAppBanner.defaultProps = {
  currentAd: {}
};

export default MobileAppBanner;



// WEBPACK FOOTER //
// ./src/components/MobileAppBanner/MobileAppBanner.tsx